/* ═══════════════════════════════════════════════════════════════════
   MATRIKAR — Cart Drawer JS (externalized P6 — 2026-05-22)
   Source : sections/cart-drawer.liquid (block 2, formerly inline)
   Loaded : defer, on every page (cart-drawer is global)
   Reads bootstrap inline globals : window.MK_CART_CURRENCY_ISO,
                                    window.MK_CART_TRASH_ICON_SVG
   ═══════════════════════════════════════════════════════════════════ */

(function () {
  // ---------- P1 (2026-08-05) : émetteur du bus panier, idempotent + global (safe hors PDP où cart-unified est absent) ----------
  window.mkEmitCartChanged = window.mkEmitCartChanged || function (cart, source) {
    try { document.dispatchEvent(new CustomEvent('mk:cart:changed', { bubbles: true, detail: { cart: cart, source: source || '' } })); } catch (e) { /* noop */ }
  };

  // ---------- DOM Elements ----------
  const drawer = document.getElementById('mkCartDrawer');
  const backdrop = document.getElementById('mkCartBackdrop');
  const cartItemsContainer = document.getElementById('mkCartItems');
  const cartEmptyDiv = document.getElementById('mkCartEmpty');
  const cartTotalsSpan = document.getElementById('mkCartTotals');
  const cartCountSpan = document.getElementById('mkCartCount');
  const checkoutTotalSpan = document.getElementById('mkCheckoutTotal');

  let cachedCart = null;
  let isFetching = false; // simple guard — does NOT block UI open
  let refreshQueued = false; // coalesce : si un refresh est demandé pendant un fetch, on en relance UN après
  // P2 : `lastRenderSig` supprimé — le diff/patch est idempotent, un rendu redondant n'écrit rien.

  // HOTFIX_BUNDLE_SYSTEM_V22 — currency code USD/CAD via cart.currency.iso_code (server-side injection)
  function formatMoney(amount) {
    return '$' + parseFloat(amount).toFixed(2);
  }
  // P-PROMO : version AVEC code devise — réservée au subtotal / total checkout.
  function formatMoneyWithCode(amount) {
    var code = (window.MK_CART_CURRENCY_ISO || 'USD');
    return formatMoney(amount) + ' ' + code;
  }
  function getProductImage(item) {
    if (!item.image) return null;
    // P-CART perf #1 : vignette ~88px -> sert 176px (retina) au lieu du master full-res
    return item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=176';
  }

  // P6 EXTRACT : trash icon SVG (was inline Liquid render 'icon' matrikar-trash)
  // Source : snippets/icon.liquid when 'matrikar-trash'
  const TRASH_ICON_SVG = (window.MK_CART_TRASH_ICON_SVG || '<svg aria-hidden="true" focusable="false" fill="none" width="18" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>');

  // ---------- Perfect Fit Guarantee accordion (PDP green style, cf snippets/matrikar-vehicle-fit.liquid) ----------
  const FIT_SHIELD_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="#1a7a3a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></svg>';
  const FIT_CHEV_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="6 9 12 15 18 9"/></svg>';

  // Summary line: {Vehicle} ({Vehicle Year}) {Seats} · {Drive Side} · {Fuel Type}
  function getPropCI(props, name) {
    for (const k in props) {
      if (Object.prototype.hasOwnProperty.call(props, k) && k.toLowerCase() === name.toLowerCase() && props[k]) return props[k];
    }
    return '';
  }
  function buildFitSummary(props) {
    props = props || {};
    const vehicle = getPropCI(props, 'Vehicle');
    const year = getPropCI(props, 'Vehicle Year');
    const seats = getPropCI(props, 'Seats') || getPropCI(props, 'Number of seats');
    const drive = getPropCI(props, 'Drive Side');
    const fuel = getPropCI(props, 'Fuel Type');
    let head = vehicle;
    if (year) head += (head ? ' ' : '') + '(' + year + ')';
    if (seats) head += (head ? ' ' : '') + seats;
    return [head, drive, fuel].filter(Boolean).join(' · ');
  }

  // Accessoire universel (tag no-vehicle-fit) → pas d'encadré "Perfect Fit Guarantee".
  // Map serveur (window.MK_CART_NO_FIT) prioritaire ; fallback sur l'absence de propriétés de fit
  // véhicule pour les produits ajoutés après le chargement de la page (absents de la map).
  function productHasNoFit(item) {
    const map = window.MK_CART_NO_FIT || {};
    if (Object.prototype.hasOwnProperty.call(map, item.product_id)) return !!map[item.product_id];
    const p = item.properties || {};
    const fitKeys = ['Vehicle', 'Vehicle Year', 'Seats', 'Drive Side', 'Fuel Type'];
    return !fitKeys.some((k) => getPropCI(p, k));
  }

  // ---------- Dynamic review stars (note + nb d'avis par produit, metafield AliReviews) ----------
  // Display-only. Mirrors snippets/mk-cart-review-stars.liquid exactly so the
  // drawer and the /cart page render an identical line. NO fetch.
  // Étoiles d'avis DYNAMIQUES par produit : rating + count viennent de window.MK_CART_REVIEWS
  // (map product_id → [ratingValue, reviewCount], injectée serveur depuis le metafield AliReviews
  // rating_info — cf cart-drawer.liquid + product-info.liquid). Miroir exact de
  // snippets/mk-cart-review-stars.liquid. `uid` garde les ids de gradient uniques par ligne.
  // Fallback : count<=0 / NaN → '' (aucune étoile, aucun nombre).
  var STAR_PATH = '<path d="M8 0l2.47 5L16 5.82l-4 3.9.94 5.5L8 12.6l-4.94 2.62L4 9.72 0 5.82 5.53 5z"/>';
  function reviewStarsHtml(rating, count, uid) {
    count = parseInt(count, 10);
    rating = parseFloat(rating);
    if (!count || count <= 0 || isNaN(rating)) return '';

    var stars = '';
    for (var i = 1; i <= 5; i++) {
      var fill = Math.round((rating - (i - 1)) * 100);
      if (fill > 100) fill = 100;
      if (fill < 0) fill = 0;
      if (fill >= 100) {
        stars += '<svg width="13" height="13" viewBox="0 0 16 16" fill="#FFC107" xmlns="http://www.w3.org/2000/svg" focusable="false" style="display:block;">' + STAR_PATH + '</svg>';
      } else if (fill <= 0) {
        stars += '<svg width="13" height="13" viewBox="0 0 16 16" fill="#E0E0E0" xmlns="http://www.w3.org/2000/svg" focusable="false" style="display:block;">' + STAR_PATH + '</svg>';
      } else {
        var gid = 'mkCartStar' + uid + '-' + i;
        stars += '<svg width="13" height="13" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" style="display:block;"><defs><linearGradient id="' + gid + '"><stop offset="' + fill + '%" stop-color="#FFC107"/><stop offset="' + fill + '%" stop-color="#E0E0E0"/></linearGradient></defs><path d="M8 0l2.47 5L16 5.82l-4 3.9.94 5.5L8 12.6l-4.94 2.62L4 9.72 0 5.82 5.53 5z" fill="url(#' + gid + ')"/></svg>';
      }
    }
    var _starsAria = (((window.MK_I18N || {}).cart_stars_aria) || 'Rated {rating} out of 5 stars, {count} reviews').replace('{rating}', rating).replace('{count}', count);
    return '<div class="mk-cart-stars" aria-label="' + _starsAria + '" style="display:flex;align-items:center;gap:5px;margin:0 0 3px;line-height:1;">'
      + '<span aria-hidden="true" style="display:inline-flex;gap:1px;">' + stars + '</span>'
      + '<span style="font-family:\'Urbanist\',system-ui,-apple-system,sans-serif;font-weight:600;font-size:12px;letter-spacing:0.02em;color:#717182;">(' + count + ')</span>'
      + '</div>';
  }

  // ---------- Fetch helpers ----------
  async function fetchCart() {
    var _root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    const res = await fetch(_root + 'cart.js');
    return res.json();
  }

  // ---------- Core refresh — always runs, no lock ----------
  async function refreshCartDrawer() {
    // Coalesce : un refresh demandé pendant un fetch en cours n'est PAS jeté (bug « ne se re-rend
    // pas toujours avec la nouvelle ligne »). On mémorise et on relance UN refresh à la fin -> le
    // rendu final reflète toujours l'état RÉEL du panier (article + cadeau gratuit auto-ajouté).
    if (isFetching) { refreshQueued = true; return; }
    isFetching = true;
    try {
      const cart = await fetchCart();
      cachedCart = cart;
      window.currentCart = cart;
      renderCartItems(cart);
      renderTotals(cart);
    } catch (err) {
      console.error('Cart refresh error:', err);
    } finally {
      isFetching = false;
      if (refreshQueued) { refreshQueued = false; refreshCartDrawer(); }
    }
  }

  // ---------- Render ----------

  // Keys to rename for display
  const KEY_LABELS = {
    'Number of seats': 'Coverage',
    'Select Set':      'Coverage',
  };
  function getDisplayKey(key) {
    // Translated display labels for vehicle-fit properties (matching stays on the English keys).
    var I = window.MK_I18N || {};
    var LOC = {
      'Vehicle': I.cart_prop_vehicle,
      'Vehicle Year': I.cart_prop_vehicle_year,
      'Trim': I.cart_prop_trim,
      'Seats': I.cart_prop_seats,
      'Drive Side': I.cart_prop_drive_side,
      'Fuel Type': I.cart_prop_fuel_type,
      'Number of seats': I.cart_prop_coverage,
      'Select Set': I.cart_prop_coverage
    };
    return LOC[key] || KEY_LABELS[key] || key;
  }
  function isValidPropertyKey(key) {
    return !key.startsWith('_');
  }

  // Property display order: Option/Coverage first, then vehicle info
  const PROP_ORDER = [
    'Option', 'Select Set', 'Number of seats',
    'Vehicle', 'Vehicle Year', 'Trim', 'Seats', 'Drive Side', 'Fuel Type',
  ];
  function sortProps(entries) {
    return entries.slice().sort(([a], [b]) => {
      const ai = PROP_ORDER.indexOf(a);
      const bi = PROP_ORDER.indexOf(b);
      if (ai === -1 && bi === -1) return 0;
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    });
  }

  /**
   * Mirror full-page cart Liquid logic:
   * 1. Look for explicit 'Option' and 'Coverage'/'Number of seats' properties
   * 2. If not found, extract from variant title split by ' / '
   *    — first segment = Option, second = Coverage
   * Returns { optionValue, coverageValue, remainingProps }
   */
  function extractOptionCoverage(item) {
    const props = item.properties || {};
    let optionValue = '';
    let coverageValue = '';
    const remaining = []; // all other valid props

    for (const [k, v] of Object.entries(props)) {
      if (!v || !isValidPropertyKey(k)) continue;
      const kd = k.toLowerCase();
      if (kd === 'option') {
        optionValue = v;
      } else if (kd === 'coverage' || kd === 'number of seats' || kd === 'select set') {
        coverageValue = v;
      } else {
        remaining.push([k, v]);
      }
    }

    // Fallback: parse from variant title (e.g. "All Black - Diamond / Front Only")
    const vt = item.variant_title;
    if (vt && vt !== 'Default Title') {
      const parts = vt.split(/\s*\/\s*/);
      if (!optionValue && parts[0]) optionValue = parts[0].trim();
      if (!coverageValue && parts[1]) coverageValue = parts[1].trim();
    }

    return { optionValue, coverageValue, remaining };
  }

  // ═══════════════════════════════════════════════════════════════════
  // P2 (2026-08-05) — RENDU CHIRURGICAL (diff / patch)
  //
  // AVANT : renderCartItems concaténait tout le HTML puis faisait
  //   `cartItemsContainer.innerHTML = html`
  // → TOUTES les rangées (et donc tous les <img>) étaient détruites puis recréées à CHAQUE
  // événement panier : les images reflashaient et le scroll de `.cart-body` sautait.
  //
  // DÉSORMAIS : on rapproche le DOM du panier rangée par rangée, chaque rangée identifiée par la
  // CLÉ DE LIGNE SHOPIFY (`item.key`, portée par `data-key`).
  //   • clé déjà présente  → mise à jour EN PLACE (updateItemRow), le nœud n'est PAS recréé
  //   • clé nouvelle       → insertion de CETTE rangée seulement
  //   • clé disparue       → retrait de CETTE rangée seulement
  //
  // POURQUOI la clé suffit : la clé Shopify vaut `<variant_id>:<hash des properties>`. À clé
  // ÉGALE, la variante ET les properties sont donc identiques → titre, image, étoiles d'avis et
  // bloc « Perfect Fit Guarantee » sont INVARIANTS pour une rangée survivante. Seuls la quantité
  // et les prix de ligne peuvent bouger : c'est exactement (et uniquement) ce que met à jour
  // updateItemRow. Le <img> n'est jamais retouché → zéro reflash.
  //
  // La ligne cadeau n'a rien de spécial ici : c'est une rangée à clé stable comme les autres,
  // elle s'insère / se retire par le diff sans reconstruire la liste.
  //
  // L'ancien garde anti-shake `lastRenderSig` est SUPPRIMÉ : il existait uniquement pour éviter de
  // reconstruire le DOM à l'identique. Le diff est naturellement idempotent — un rendu redondant
  // n'écrit plus rien dans le DOM.
  // ═══════════════════════════════════════════════════════════════════

  // Conteneur scrollable du drawer (sections/cart-drawer.liquid:176 — `.cart-body`, overflow-y:auto).
  // #mkCartItems en est un enfant : c'est donc `.cart-body` qui porte le scrollTop à préserver.
  function scrollBox() {
    return drawer ? drawer.querySelector('.cart-body') : null;
  }

  // MK_PERSONALIZATION 2026-08-30 — la ligne qui facture le supplément de finition
  // (produit `mat-personalization`). Elle est marquée par la propriété `_mk_perso_addon`.
  function isPersoAddon(item) {
    return !!(item && item.properties && item.properties._mk_perso_addon);
  }

  function buildItemHtml(item) {
    const I = window.MK_I18N || {};

    // MK_PERSONALIZATION — rendu EN SOUS-LIGNE, rattaché visuellement au tapis qui la précède :
    // pas de vignette, pas de corbeille, pas de sélecteur de quantité. Le client voit un produit
    // avec son option, pas deux produits. Le retrait se fait avec le tapis (cf. trashHandler).
    if (isPersoAddon(item)) {
      const persoTotal = item.final_line_price / 100;
      const persoLabel = item.properties._mk_perso_label || item.variant_title || item.product_title;
      const persoImg = item.properties._mk_perso_img || '';
      return `
        <div class="cart-item cart-item--perso" data-key="${item.key}" data-mk-perso-row>
          ${persoImg ? `<span class="cart-perso-thumb"><img src="${persoImg}" alt="${persoLabel}" width="44" height="44" loading="lazy" decoding="async"></span>` : ''}
          <div class="cart-perso-info">
            <span class="cart-perso-label">${persoLabel}</span>
            <span class="cart-perso-sub">${I.cart_perso_sub || 'Added to this set'}</span>
          </div>
          <span class="cart-perso-price">${formatMoney(persoTotal)}</span>
        </div>
      `;
    }

    {
      const lineTotal = item.final_line_price / 100;
      const compareTotal = item.original_line_price / 100;

      // Extract Option + Coverage exactly like full-page Liquid cart
      const { optionValue, coverageValue, remaining } = extractOptionCoverage(item);

      // Build "Perfect Fit Guarantee" accordion: Option → Coverage → vehicle props (sorted)
      let fitRows = '';
      if (optionValue)   fitRows += `<div class="cart-fit-row"><span class="cart-fit-k">${I.cart_prop_option || 'Option'}:</span> <span class="cart-fit-v">${optionValue}</span></div>`;
      if (coverageValue) fitRows += `<div class="cart-fit-row"><span class="cart-fit-k">${I.cart_prop_coverage || 'Coverage'}:</span> <span class="cart-fit-v">${coverageValue}</span></div>`;

      // Remaining props sorted by vehicle order
      const sorted = sortProps(remaining);
      for (const [key, val] of sorted) {
        fitRows += `<div class="cart-fit-row"><span class="cart-fit-k">${getDisplayKey(key)}:</span> <span class="cart-fit-v">${val}</span></div>`;
      }

      const fitSummary = buildFitSummary(item.properties);
      let fitHtml = '';
      // Accessoire universel (tag no-vehicle-fit) : AUCUNE propriété sous le titre.
      if (fitRows && !productHasNoFit(item)) {
          fitHtml = `<details class="cart-fit">
              <summary class="cart-fit-sum">
                <span class="cart-fit-ico">${FIT_SHIELD_SVG}</span>
                <span class="cart-fit-text">
                  <span class="cart-fit-title">${I.cart_perfect_fit || 'Perfect Fit Guarantee'}</span>
                  ${fitSummary ? `<span class="cart-fit-line">${fitSummary}</span>` : ''}
                </span>
                <span class="cart-fit-chev">${FIT_CHEV_SVG}</span>
              </summary>
              <div class="cart-fit-body">${fitRows}</div>
            </details>`;
      }

      // Title = product title only (Option/Coverage shown as props below)
      const displayTitle = item.product_title;

      // Étoiles d'avis dynamiques (note + nb par produit via window.MK_CART_REVIEWS) — exclues sur le cadeau BXGY.
      const isGiftLine = !!(item.properties && item.properties._free_gift === 'diamond-trunk-small');
      const reviewData = (window.MK_CART_REVIEWS || {})[item.product_id];
      const starsHtml = (isGiftLine || !reviewData) ? '' : reviewStarsHtml(reviewData[0], reviewData[1], 'D' + String(item.key).replace(/[^a-zA-Z0-9]/g, ''));

      const imgUrl = getProductImage(item);
      return `
        <div class="cart-item" data-key="${item.key}"${isGiftLine ? ' data-mk-gift-row' : ''}>
          <button class="cart-item-trash" data-key="${item.key}" aria-label="${(I.cart_remove || 'Remove {title}').replace('{title}', item.title)}">
            ${TRASH_ICON_SVG}
          </button>
          <div class="cart-item-img" data-zoom-handle="${item.handle}">${imgUrl ? `<img src="${imgUrl}" alt="${item.title}" width="80" height="80" loading="lazy" decoding="async">` : '<span class="cart-item-img-ph">' + (I.cart_image || 'Image') + '</span>'}</div>
          <div class="cart-item-info">
            ${starsHtml}
            <h3 class="cart-item-name">${displayTitle}</h3>
            ${fitHtml}
            <div class="cart-item-bottom">
              ${isGiftLine
                ? `<div class="cart-qty cart-qty--locked" aria-label="${I.cart_qty_locked || 'Quantity locked'}"><span class="cart-qty-num">${item.quantity}</span></div>`
                : `<div class="cart-qty">
                <button class="cart-qty-btn" data-key="${item.key}" data-delta="-1" aria-label="${I.cart_qty_decrease || 'Decrease quantity'}" ${item.quantity <= 1 ? 'disabled' : ''}>−</button>
                <span class="cart-qty-num">${item.quantity}</span>
                <button class="cart-qty-btn" data-key="${item.key}" data-delta="1" aria-label="${I.cart_qty_increase || 'Increase quantity'}">+</button>
              </div>`}
              <div class="cart-item-price-block">
                ${compareTotal > lineTotal ? `<span class="cart-item-compare">${formatMoney(compareTotal)}</span>` : ''}
                <span class="cart-item-price">${formatMoney(lineTotal)}</span>
              </div>
            </div>
            ${compareTotal > lineTotal ? `<div class="cart-item-savings">(${I.cart_save || 'Save'} ${formatMoney(compareTotal - lineTotal)})</div>` : ''}
          </div>
        </div>
      `;
    }
  }

  // Avance jusqu'à la prochaine RANGÉE de panier, en sautant les nœuds étrangers déposés dans le
  // conteneur par d'autres modules (cf. le squelette cadeau de mk-gift.js:303).
  function nextItemFrom(node) {
    while (node && !node.classList.contains('cart-item')) node = node.nextElementSibling;
    return node;
  }

  // IDENTITÉ STABLE d'une ligne — variante + properties canonisées.
  //
  // MESURÉ le 2026-08-05 (drawer, ajout d'un tapis éligible) : Shopify RE-CLÉ la ligne tapis quand
  // le cadeau BXGY s'ajoute, alors que ses properties sont STRICTEMENT identiques :
  //     bus `unified-add` → 45876505903265:8af692fb…
  //     bus `gift`        → 45876505903265:1926e075…
  // seule différence sur la ligne : l'allocation de remise « Free Trunk Organizer - Summer Promo »,
  // que Shopify intègre au hash de la clé.
  // Conséquence : indexer UNIQUEMENT par `item.key` ferait détruire puis recréer la rangée à chaque
  // arrivée du cadeau → image recréée = reflash, dans le scénario le PLUS courant (ajout au panier).
  // D'où ce second critère d'appariement, insensible aux remises.
  function lineIdentity(item) {
    const p = item.properties || {};
    return item.id + '|' + Object.keys(p).sort().map((k) => k + '=' + p[k]).join('');
  }

  // Resynchronise la clé Shopify portée par la rangée ET par ses boutons (les handlers lisent
  // `data-key` : sans ça, après un re-clé, poubelle et +/− cibleraient une ligne inexistante).
  function rekeyRow(row, item) {
    if (row.getAttribute('data-key') === item.key) return;
    row.setAttribute('data-key', item.key);
    row.querySelectorAll('[data-key]').forEach((el) => el.setAttribute('data-key', item.key));
  }

  // Crée le nœud d'une rangée à partir du HTML (INSERTION uniquement).
  function createItemNode(item) {
    const tpl = document.createElement('template');
    tpl.innerHTML = buildItemHtml(item).trim();
    const node = tpl.content.firstElementChild;
    node.setAttribute('data-mk-ident', lineIdentity(item));
    return node;
  }

  // Écrit une valeur texte SEULEMENT si elle a changé (aucune écriture DOM inutile).
  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  // Mise à jour EN PLACE d'une rangée survivante. Ne touche QUE ce qui peut varier à clé égale :
  // quantité, état des boutons +/−, prix de ligne, prix barré, ligne d'économie.
  // Ne touche JAMAIS le <img>, le titre, les étoiles ni le bloc Perfect Fit (invariants à clé égale).
  function updateItemRow(row, item) {
    const I = window.MK_I18N || {};

    // MK_PERSONALIZATION — la sous-ligne n'a ni quantité ni prix barré : seul son total peut bouger.
    if (isPersoAddon(item)) {
      setText(row.querySelector('.cart-perso-price'), formatMoney(item.final_line_price / 100));
      return;
    }

    const lineTotal = item.final_line_price / 100;
    const compareTotal = item.original_line_price / 100;
    const discounted = compareTotal > lineTotal;

    setText(row.querySelector('.cart-qty-num'), String(item.quantity));

    // P3 : pendant une mutation en vol la rangée est verrouillée (data-mk-locked) — un rendu
    // intermédiaire ne doit PAS réactiver les boutons. unlockRow() ré-appliquera l'état exact.
    const minusBtn = row.querySelector('.cart-qty-btn[data-delta="-1"]');
    if (minusBtn && !row.hasAttribute('data-mk-locked')) {
      const shouldDisable = item.quantity <= 1;
      if (minusBtn.disabled !== shouldDisable) minusBtn.disabled = shouldDisable;
    }

    setText(row.querySelector('.cart-item-price'), formatMoney(lineTotal));

    // Prix barré : présent seulement si remise. On crée/retire le seul nœud concerné.
    const priceBlock = row.querySelector('.cart-item-price-block');
    let compareEl = row.querySelector('.cart-item-compare');
    if (discounted) {
      if (!compareEl && priceBlock) {
        compareEl = document.createElement('span');
        compareEl.className = 'cart-item-compare';
        priceBlock.prepend(compareEl);
      }
      setText(compareEl, formatMoney(compareTotal));
    } else if (compareEl) {
      compareEl.remove();
    }

    // Ligne « (Save X) » : idem, ciblée.
    const info = row.querySelector('.cart-item-info');
    let savingsEl = row.querySelector('.cart-item-savings');
    if (discounted) {
      if (!savingsEl && info) {
        savingsEl = document.createElement('div');
        savingsEl.className = 'cart-item-savings';
        info.append(savingsEl);
      }
      setText(savingsEl, '(' + (I.cart_save || 'Save') + ' ' + formatMoney(compareTotal - lineTotal) + ')');
    } else if (savingsEl) {
      savingsEl.remove();
    }
  }

  // MK_PERSONALIZATION 2026-08-30 — REMET LA SOUS-LIGNE DERRIÈRE SON TAPIS.
  //
  // MESURÉ le 2026-08-30 : ajouté juste après le tapis, l'add-on ressort pourtant EN TÊTE de
  // /cart.js (une app repose des properties sur la ligne tapis — `_visitor_id` — ce qui la recrée
  // en fin de liste). L'ordre d'ajout n'est donc PAS une garantie : on réordonne au rendu.
  //
  // Appariement : `_mk_perso_for` (variant du tapis) d'abord ; à défaut — paniers créés avant que
  // la propriété existe — le premier tapis encore libre. Un add-on sans tapis reste rendu en fin
  // de liste plutôt que masqué : le client doit voir tout ce qu'il paie.
  function orderPersoAddons(items) {
    const list = items || [];
    if (!list.some(isPersoAddon)) return list;

    const addons = list.filter(isPersoAddon);
    const placed = new Set();
    const out = [];

    for (const item of list) {
      if (isPersoAddon(item)) continue;
      out.push(item);
      if (String(item.product_type || '').toLowerCase() !== 'car mats') continue;

      let match = addons.find((a) => !placed.has(a) && String(a.properties._mk_perso_for || '') === String(item.variant_id || item.id));
      if (!match) match = addons.find((a) => !placed.has(a) && !a.properties._mk_perso_for);
      if (match) { placed.add(match); out.push(match); }
    }

    addons.forEach((a) => { if (!placed.has(a)) out.push(a); });
    return out;
  }

  // 1er nov 2026 : le chargeur offert passe sous les tapis, comme sur la page panier.
  function giftLinesLast(items) {
    const list = items || [];
    const isGift = (it) => !!((it.properties && it.properties._free_gift) || it.handle === 'gift-wireless-car-charger');
    if (!list.some(isGift)) return list;
    return list.filter((it) => !isGift(it)).concat(list.filter(isGift));
  }

  // ---------- Le diff/patch ----------
  function renderCartItems(cart) {
    const foot = document.querySelector('.cart-foot');
    const box = scrollBox();
    const savedScroll = box ? box.scrollTop : 0;   // (3) scroll sauvé AVANT toute mutation

    // Le skeleton n'est pas une rangée de panier : on le retire toujours avant de patcher.
    cartItemsContainer.querySelectorAll('.mk-cart-skel-row').forEach((n) => n.remove());

    if (!cart.items.length) {
      cartItemsContainer.querySelectorAll('.cart-item').forEach((n) => n.remove());
      cartEmptyDiv.classList.add('visible');
      if (foot) foot.style.display = 'none';
      return;
    }

    if (cartEmptyDiv.classList.contains('visible')) cartEmptyDiv.classList.remove('visible');
    if (foot && foot.style.display === 'none') foot.style.display = '';

    // MK_PERSONALIZATION — ordre d'affichage : chaque supplément juste derrière son tapis.
    const orderedItems = giftLinesLast(orderPersoAddons(cart.items));

    // Index des rangées présentes : par CLÉ, et par IDENTITÉ STABLE (repli, cf. lineIdentity).
    const rows = Array.prototype.slice.call(cartItemsContainer.querySelectorAll('.cart-item'));
    const byKey = new Map();
    const byIdent = new Map();
    const claimed = new Set();
    rows.forEach((n) => {
      byKey.set(n.getAttribute('data-key'), n);
      const id = n.getAttribute('data-mk-ident') || '';
      if (!byIdent.has(id)) byIdent.set(id, []);
      byIdent.get(id).push(n);
    });

    // Réserve la rangée existante correspondant à cet article : clé exacte d'abord, sinon une
    // rangée non encore réservée de MÊME identité stable (cas du re-clé par remise).
    const claimRow = (item) => {
      const exact = byKey.get(item.key);
      if (exact && !claimed.has(exact)) { claimed.add(exact); return exact; }
      const pool = byIdent.get(lineIdentity(item));
      if (pool) {
        for (let i = 0; i < pool.length; i++) {
          if (!claimed.has(pool[i])) { claimed.add(pool[i]); return pool[i]; }
        }
      }
      return null;
    };

    // PASSE 1 — appariement PUR : on décide quelle rangée sert quel article, sans AUCUNE écriture DOM.
    const plan = orderedItems.map((item) => ({ item, row: claimRow(item) }));

    // PASSE 2 — retrait des rangées disparues AVANT le repositionnement.
    // MESURÉ (2026-08-05, retrait de la ligne cadeau en TÊTE de liste) : en retirant après coup, la
    // rangée condamnée sert encore de curseur → elle ne correspond jamais à l'article attendu, donc
    // toutes les rangées suivantes sont DÉPLACÉES (insertBefore) devant elle avant sa suppression.
    // Trace observée : « -1/+1, -1/+1, -1 » pour un simple retrait. En supprimant d'abord, le
    // curseur démarre sur la bonne rangée → « -1 » et rien d'autre.
    rows.forEach((n) => { if (!claimed.has(n)) n.remove(); });

    // PASSE 3 — mise à jour en place, insertion des nouvelles, remise en ordre si nécessaire.
    // `cursor` = rangée attendue à la position courante ; on n'appelle insertBefore que si besoin.
    //
    // ATTENTION — le conteneur n'héberge PAS que des rangées : mk-gift.js:303 y appende son
    // squelette « Adding your trunk organizer… » (.mk-gift-skeleton) pendant l'ajout du cadeau, et
    // le retire lui-même. Le curseur doit donc ignorer tout nœud étranger : sinon il tombe dessus,
    // ne correspond jamais à la rangée attendue, et on DÉPLACE des rangées déjà bien placées.
    let cursor = nextItemFrom(cartItemsContainer.firstElementChild);
    let lastPlaced = null;

    for (const entry of plan) {
      let row = entry.row;

      if (row) {
        rekeyRow(row, entry.item);             // la clé Shopify a pu changer (remise) — on la resynchronise
        updateItemRow(row, entry.item);        // EN PLACE — nœud conservé, <img> intact
      } else {
        row = createItemNode(entry.item);      // rangée NOUVELLE — seule celle-ci est créée
      }

      if (cursor === row) {
        cursor = nextItemFrom(row.nextElementSibling);  // déjà à la bonne place : aucune écriture DOM
      } else if (cursor) {
        cartItemsContainer.insertBefore(row, cursor);
      } else if (lastPlaced) {
        lastPlaced.after(row);                 // après la dernière rangée : DEVANT un éventuel nœud étranger de fin
      } else {
        cartItemsContainer.prepend(row);
      }
      lastPlaced = row;
    }

    if (box && box.scrollTop !== savedScroll) box.scrollTop = savedScroll;  // (3) scroll restauré
  }

  /* ═══════════════════════════════════════════════════════════════════
     P3 (2026-08-05) — FEEDBACK BOUTONS + UI OPTIMISTE

     VOLET A — états visuels sur TOUS les boutons du drawer (± / poubelle / checkout), calqués sur
     le pattern déjà en place pour l'ATC de la PDP (snippets/buy-buttons.liquid:382-411) :
       • :active:not([disabled])   → press-scale
       • [aria-busy="true"]        → pointer-events:none + spinner (mêmes 600ms linear)
       • [disabled]                → état visible (il ne l'était PAS : `.cart-qty-btn` n'avait
                                     aucune règle :disabled dans sections/cart-drawer.liquid:81)
     Le CSS est injecté par JS, comme ensureSkeletonStyles() plus bas → un seul fichier touché.

     VOLET B — UI optimiste : au clic on rend IMMÉDIATEMENT le résultat attendu en réutilisant le
     patch en place de P2 (renderCartItems/renderTotals nourris par un panier PRÉDIT), puis on
     réconcilie avec la réponse serveur via le bus. `window.currentCart` n'est JAMAIS écrasé par une
     prédiction : il reste la dernière vérité serveur, base du rollback et du calcul des quantités.

     LE POINT DÉLICAT — le spinner doit tenir jusqu'à la réconciliation COMPLÈTE, cadeau inclus.
     L'ancien `finally` (cart-drawer.js, avant P3) relâchait dès le retour de change.js, donc AVANT
     que mk-gift n'ait ajouté/retiré le cadeau → le spinner s'arrêtait et le cadeau « poppait »
     après. On attend donc, quand un changement de cadeau est attendu, l'événement bus final
     `source:'gift'` — borné par un plafond pour ne jamais figer l'UI.
     ═══════════════════════════════════════════════════════════════════ */

  const ACTION_STYLE_ID = 'mk-cart-action-style';
  function ensureActionStyles() {
    if (document.getElementById(ACTION_STYLE_ID)) return;
    const st = document.createElement('style');
    st.id = ACTION_STYLE_ID;
    st.textContent = [
      // press-scale (VOLET A — « qu'on ressente le clic »)
      '.cart-qty-btn:active:not([disabled]),.cart-item-trash:active:not([disabled]){transform:scale(.9);transition:transform 100ms ease-out}',
      '.cart-checkout:active:not([disabled]){transform:scale(.99);transition:transform 100ms ease-out}',
      // disabled — action impossible (ex. « − » à qty 1)
      '.cart-qty-btn[disabled]{opacity:.28;cursor:default}',
      '.cart-item-trash[disabled]{opacity:.4;cursor:default}',
      // busy — commun
      '.cart-qty-btn[aria-busy="true"],.cart-item-trash[aria-busy="true"],.cart-checkout[aria-busy="true"]{pointer-events:none;position:relative}',
      // busy — petits boutons : le glyphe s'efface, le spinner prend sa place (centré)
      '.cart-qty-btn[aria-busy="true"]{color:transparent;opacity:1}',
      '.cart-item-trash[aria-busy="true"]{opacity:1}',
      '.cart-item-trash[aria-busy="true"] svg{opacity:0}',
      '.cart-qty-btn[aria-busy="true"]::after,.cart-item-trash[aria-busy="true"]::after{content:"";position:absolute;top:50%;left:50%;width:14px;height:14px;margin:-7px 0 0 -7px;border:2px solid rgba(3,2,19,.18);border-top-color:#030213;border-radius:50%;animation:mk-cart-spin 600ms linear infinite}',
      // busy — checkout : libellé conservé, la flèche cède la place au spinner
      '.cart-checkout[aria-busy="true"]{opacity:.85}',
      '.cart-checkout[aria-busy="true"] svg{display:none}',
      '.cart-checkout[aria-busy="true"]::after{content:"";display:inline-block;width:14px;height:14px;border:2px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:mk-cart-spin 600ms linear infinite}',
      // rangée en cours de retrait / de réconciliation cadeau
      '.cart-item[data-mk-removing]{opacity:.45;transition:opacity 120ms ease-out}',
      '.cart-item[data-mk-settling]{opacity:.55;transition:opacity 120ms ease-out}',
      // succès bref (subtil)
      '.cart-qty-btn[data-mk-ok]{animation:mk-cart-ok 340ms ease-out}',
      '@keyframes mk-cart-spin{to{transform:rotate(360deg)}}',
      '@keyframes mk-cart-ok{0%{background:rgba(26,122,58,.16)}100%{background:transparent}}'
    ].join('');
    document.head.appendChild(st);
  }

  // ---------- Verrou de rangée ----------
  // Une mutation en vol verrouille TOUTE sa rangée (pas seulement le bouton cliqué) : c'est
  // l'anti-double-clic, et ça empêche « + » et poubelle de partir en parallèle sur la même ligne.
  // `data-mk-locked` dit aussi à updateItemRow de ne pas réactiver « − » pendant le vol.
  function lockRow(row, busyBtn) {
    if (busyBtn) busyBtn.setAttribute('aria-busy', 'true');
    if (!row) return;
    row.setAttribute('data-mk-locked', '1');
    row.querySelectorAll('.cart-qty-btn, .cart-item-trash').forEach((b) => { b.disabled = true; });
  }
  function unlockRow(row) {
    if (!row) return;
    row.removeAttribute('data-mk-locked');
    row.removeAttribute('data-mk-removing');
    row.querySelectorAll('.cart-qty-btn, .cart-item-trash').forEach((b) => {
      b.removeAttribute('aria-busy');
      b.disabled = false;
    });
    // Ré-applique l'état EXACT depuis la vérité serveur (« − » redevient disabled si qty 1).
    const key = row.getAttribute('data-key');
    const item = ((window.currentCart && window.currentCart.items) || []).find((i) => i.key === key);
    if (item) updateItemRow(row, item);
  }
  function flashOk(btn) {
    if (!btn) return;
    btn.setAttribute('data-mk-ok', '1');
    setTimeout(() => btn.removeAttribute('data-mk-ok'), 360);
  }

  // ---------- Attente de la réconciliation cadeau ----------
  // Prédit si mk-gift va muter le panier À LA SUITE de cette mutation. Sert UNIQUEMENT au timing du
  // spinner. Miroir des règles de mk-gift.js:62-71 (éligibilité) et :162 / :167 / :178 (branches
  // retrait auto / dédoublonnage / ajout auto).
  // COUPLAGE ASSUMÉ : si la règle dérive, la seule conséquence est un spinner relâché trop tôt, ou
  // relâché au plafond. Jamais un panier faux — l'état affiché vient toujours du diff P2 sur le
  // panier SERVEUR. Le plafond garantit qu'on sort toujours.
  const GIFT_MARKER = 'diamond-trunk-small';
  const GIFT_SETTLE_CAP = 4000;
  function isGiftItem(it) { const p = it.properties || {}; return p._free_gift === GIFT_MARKER; }
  function isEligibleMatItem(it) {
    if ((it.product_type || '').toLowerCase() !== 'car mats') return false;
    const parts = String(it.variant_title || '').split('/');
    const cov = (parts.length > 1 ? parts[parts.length - 1] : '').toLowerCase().replace(/[\s\-]/g, '');
    return cov.indexOf('fullcoverage') !== -1 || cov.indexOf('3row') !== -1;
  }
  function giftChangePending(cart) {
    const items = (cart && cart.items) || [];
    const eligible = items.some(isEligibleMatItem);
    const gifts = items.filter(isGiftItem);
    if (!eligible && gifts.length > 0) return true;    // retrait auto à venir
    if (gifts.length > 1) return true;                 // dédoublonnage à venir
    if (eligible && gifts.length === 0) {
      let declined = false;
      try { declined = sessionStorage.getItem('mk_gift_declined') === '1'; } catch (e) {}
      return !declined;                                // ajout auto à venir
    }
    return false;
  }
  // Marque la ligne cadeau pendant qu'on attend son retrait (pour l'AJOUT, mk-gift affiche déjà sa
  // propre rangée « Adding your trunk organizer… » — mk-gift.js:303 — inutile d'en ajouter une).
  function markGiftSettling(on) {
    const gift = cartItemsContainer.querySelector('.cart-item[data-mk-gift-row]');
    if (gift) { if (on) gift.setAttribute('data-mk-settling', '1'); else gift.removeAttribute('data-mk-settling'); }
  }
  function waitForGiftSettle(serverCart, skip) {
    if (skip || !giftChangePending(serverCart)) return Promise.resolve(false);
    markGiftSettling(true);
    return new Promise((resolve) => {
      let done = false;
      const finish = (viaGift) => {
        if (done) return;
        done = true;
        document.removeEventListener('mk:cart:changed', onBus);
        clearTimeout(timer);
        markGiftSettling(false);
        resolve(viaGift);
      };
      const onBus = (e) => { if (e && e.detail && e.detail.source === 'gift') finish(true); };
      document.addEventListener('mk:cart:changed', onBus);
      const timer = setTimeout(() => finish(false), GIFT_SETTLE_CAP);
    });
  }

  // ---------- Panier PRÉDIT (UI optimiste) ----------
  // Clone du dernier panier SERVEUR avec la ligne ciblée ajustée, puis passé au patch P2. Le
  // sous-total optimiste est la somme des `final_line_price` : c'est une approximation (une remise
  // de panier peut différer), assumée car réconciliée quelques centaines de ms plus tard par le bus.
  function predictCart(baseCart, key, nextQty) {
    const clone = Object.assign({}, baseCart, { items: [] });
    let count = 0, total = 0;
    (baseCart.items || []).forEach((it) => {
      let line = it;
      if (it.key === key) {
        if (nextQty <= 0) return;                                   // ligne retirée
        line = Object.assign({}, it, {
          quantity: nextQty,
          final_line_price: it.final_price * nextQty,
          original_line_price: it.original_price * nextQty
        });
      }
      clone.items.push(line);
      count += line.quantity;
      total += line.final_line_price;
    });
    clone.item_count = count;
    clone.total_price = total;
    return clone;
  }

  /* ═══════════════════════════════════════════════════════════════════
     P4 (2026-08-05) — HAUTEUR DU DRAWER PILOTÉE PAR window.visualViewport

     PROBLÈME : dans le webview in-app Android de Meta (~46% du trafic), les unités viewport
     (100vh / 100svh / 100dvh) valent la hauteur de la LAYOUT viewport, plus grande que la zone
     réellement visible. `.cart-drawer` étant `position:fixed` ancré sur cette layout viewport, son
     pied — donc le bouton Checkout — tombe SOUS la barre d'outils in-app : la liste ne scrolle pas
     jusqu'à lui, le drawer paraît « coincé en bas ». C'est ce qui avait cassé au rollback de juillet.

     SOLUTION : `window.visualViewport` expose la hauteur ET le décalage RÉELLEMENT visibles. On les
     écrit dans --mk-drawer-h / --mk-drawer-top (consommés par sections/cart-drawer.liquid) et on les
     resynchronise sur `resize` ET `scroll` du visualViewport (la barre d'outils in-app apparaît /
     disparaît au scroll ; le clavier logiciel change aussi la hauteur visible).

     REPLI : si visualViewport n'existe pas (vieux navigateurs), on n'écrit RIEN → les var() gardent
     leur valeur de repli CSS (vh → svh → dvh), c'est-à-dire le comportement d'avant P4. Aucune
     régression possible pour desktop / iOS Safari, qui étaient déjà corrects.

     INTERDIT : @view-transition (blanchit le webview Meta). Rien de tel n'est ajouté ici.
     ═══════════════════════════════════════════════════════════════════ */
  // Coalescing par GARDE DE VALEUR, volontairement PAS par requestAnimationFrame : rAF est bridé
  // dès que la page n'est pas au premier plan, et c'est précisément pendant que la barre d'outils
  // in-app se rétracte (événement `scroll` du visualViewport) qu'il faut réagir sans latence.
  // Écrire seulement quand la valeur change coûte moins cher qu'une frame et ne dépend de rien.
  function syncDrawerViewport() {
    if (!drawer) return;
    const vv = window.visualViewport;
    if (!vv) return;                                    // repli CSS pur, cf. commentaire ci-dessus
    const h = Math.round(vv.height) + 'px';
    const top = Math.round(vv.offsetTop || 0) + 'px';
    // Le garde compare à ce que porte RÉELLEMENT l'élément, pas à un souvenir en variable : si un
    // tiers écrase ou retire la propriété, on la réécrit au lieu de rester bloqué sur un état périmé.
    if (drawer.style.getPropertyValue('--mk-drawer-h') === h
        && drawer.style.getPropertyValue('--mk-drawer-top') === top) return;
    drawer.style.setProperty('--mk-drawer-h', h);
    drawer.style.setProperty('--mk-drawer-top', top);
  }
  function bindViewportSync() {
    const vv = window.visualViewport;
    if (vv) {
      vv.addEventListener('resize', syncDrawerViewport);
      vv.addEventListener('scroll', syncDrawerViewport);   // barre d'outils in-app qui se rétracte
    }
    // Filets : rotation et redimensionnements que le visualViewport ne notifie pas toujours.
    window.addEventListener('orientationchange', syncDrawerViewport);
    window.addEventListener('resize', syncDrawerViewport);
    syncDrawerViewport();
  }

  // Délégation UNIQUE (P2) : les rangées survivent désormais aux rendus, donc re-binder à chaque
  // rendu (l'ancien attachFastEvents) empilerait des listeners en double sur les nœuds conservés
  // → double incrément de quantité. On délègue une seule fois, au niveau `document`, scopé à
  // #mkCartItems : aucun re-bind, et aucune dépendance à la survie du conteneur.
  let itemDelegationBound = false;
  function bindItemDelegation() {
    if (itemDelegationBound) return;
    itemDelegationBound = true;
    document.addEventListener('click', (e) => {
      const t = e.target;
      if (!t || !t.closest || !t.closest('#mkCartItems')) return;
      const qtyBtn = t.closest('.cart-qty-btn');
      if (qtyBtn) { qtyHandler(qtyBtn); return; }
      const trashBtn = t.closest('.cart-item-trash');
      if (trashBtn) { trashHandler(trashBtn); }
    });
  }

  // P2 : reçoit le BOUTON (fourni par la délégation), plus l'événement.
  // P3 : + spinner, verrou anti-double-clic, totaux optimistes, rollback, attente cadeau.
  const trashHandler = async (btn) => {
    const key = btn.getAttribute('data-key');
    if (!key) return;
    const row = btn.closest('.cart-item');
    if (row && row.hasAttribute('data-mk-locked')) return;      // (5) anti-double-clic
    const base = window.currentCart;
    const item = ((base && base.items) || []).find((i) => i.key === key);
    // Si on retire le CADEAU lui-même, mk-gift pose `mk_gift_declined` et ne le remet PAS :
    // aucun événement `gift` ne viendra → ne pas l'attendre (sinon spinner jusqu'au plafond).
    const removingGift = !!(item && isGiftItem(item));

    ensureActionStyles();
    lockRow(row, btn);
    // Optimiste : la rangée reste (elle porte le spinner) mais s'estompe, et les TOTAUX + le
    // compteur reflètent déjà son retrait. La rangée part à la réconciliation, via le diff P2.
    if (row) row.setAttribute('data-mk-removing', '1');
    if (base && item) renderTotals(predictCart(base, key, 0));

    try {
      let cart = await updateCartItem(key, 0);         // change.js → panier complet
      // MK_PERSONALIZATION — le supplément n'existe que par son tapis : quand le tapis part, sa
      // sous-ligne part avec lui, sinon le client paierait une finition sans produit à finir.
      // L'add-on est ajouté JUSTE APRÈS son tapis (cart-unified), donc c'est la ligne qui suivait
      // celle qu'on vient de retirer ; à défaut on retombe sur le plafond global
      // (jamais plus d'add-ons que de tapis au panier).
      cart = await reconcilePersoAddons(cart);
      window.mkEmitCartChanged(cart, 'drawer-trash');  // bus : render drawer + reconcile cadeau (retire le cadeau si tapis parti)
      await waitForGiftSettle(cart, removingGift);     // (1) spinner jusqu'à la réconciliation COMPLÈTE
    } catch (err) {
      if (base) { renderCartItems(base); renderTotals(base); }  // (4) rollback : retour à la vérité serveur
      console.error(err);
    } finally {
      unlockRow(row);
    }
  };

  // P2 : reçoit le BOUTON (fourni par la délégation), plus l'événement.
  // P3 : l'ancien « optimistic UI » se limitait au NOMBRE (qtySpan.innerText). Désormais on rend le
  // panier PRÉDIT par le patch P2 → quantité, prix de ligne, sous-total et compteur bougent
  // ensemble, immédiatement, avant la réponse serveur.
  const qtyHandler = async (btn) => {
    const key = btn.getAttribute('data-key');
    const delta = parseInt(btn.getAttribute('data-delta'), 10);
    if (!key || isNaN(delta)) return;
    const row = btn.closest('.cart-item');
    if (row && row.hasAttribute('data-mk-locked')) return;      // (5) anti-double-clic
    const base = window.currentCart;
    const item = base && base.items && base.items.find((i) => i.key === key);
    if (!item) return;
    const newQty = item.quantity + delta;
    if (newQty < 1) return;

    ensureActionStyles();
    lockRow(row, btn);
    const predicted = predictCart(base, key, newQty);
    renderCartItems(predicted);                        // (2) patch P2 en place — AVANT le serveur
    renderTotals(predicted);

    try {
      const cart = await updateCartItem(key, newQty);  // change.js → panier complet
      window.mkEmitCartChanged(cart, 'drawer-qty');     // bus : render + reconcile cadeau (seuil éventuel)
      await waitForGiftSettle(cart);                    // (1) spinner jusqu'à la réconciliation COMPLÈTE
      flashOk(btn);
    } catch (err) {
      renderCartItems(base); renderTotals(base);        // (4) rollback intégral vers la vérité serveur
      console.error(err);
    } finally {
      unlockRow(row);
    }
  };

  // P1 (2026-08-05) — mutations qty/suppression du drawer via /cart/change.js (par CLÉ de ligne).
  // change.js ne touche QUE la ligne ciblée → les properties des AUTRES lignes (ex. props véhicule
  // du tapis, _free_gift du cadeau) sont préservées. Retourne le panier COMPLET (pour émettre le bus).
  async function updateCartItem(key, quantity) {
    const response = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
    if (!response.ok) throw new Error('Change failed');
    return response.json();
  }

  // MK_PERSONALIZATION 2026-08-30 — PLAFOND : jamais plus de lignes de finition que de lignes de
  // tapis au panier. Retirer un tapis fait donc tomber sa finition, et un panier sans tapis ne
  // garde aucune finition orpheline.
  //
  // On raisonne sur le panier RENVOYÉ par la mutation, jamais sur des clés lues avant elle :
  // Shopify re-clé des lignes au fil des mutations (cf. la note « IDENTITÉ STABLE d'une ligne »
  // plus haut), une clé mémorisée peut donc déjà être périmée. Les surplus partent par la fin.
  async function reconcilePersoAddons(cart) {
    let current = cart;
    for (let guard = 0; guard < 4; guard++) {
      const items = (current && current.items) || [];
      const addons = items.filter(isPersoAddon);
      const mats = items.filter((i) => !isPersoAddon(i) && String(i.product_type || '').toLowerCase() === 'car mats');
      const surplus = addons.length - mats.length;
      if (surplus <= 0) return current;
      const victim = addons[addons.length - 1];
      if (!victim) return current;
      current = await updateCartItem(victim.key, 0);
    }
    return current;
  }

  // P2 — totaux CHIRURGICAUX. La structure (3 rangées) est bâtie UNE fois ; ensuite on ne réécrit
  // que les valeurs qui changent, et on affiche/masque la rangée « You saved ». Plus de
  // `cartTotalsSpan.innerHTML = html` à chaque événement.
  function buildTotalsSkeleton() {
    const I = window.MK_I18N || {};
    cartTotalsSpan.innerHTML =
      '<div class="cart-total-row"><span>' + (I.cart_shipping || 'Shipping') + '</span>'
        + '<span class="cart-total-val free">' + (I.cart_free || 'FREE') + '</span></div>'
      + '<div class="cart-total-row savings" data-mk-savings style="display:none"><span>'
        + (I.cart_you_saved || 'You saved') + '</span><span class="cart-total-val"></span></div>'
      + '<div class="cart-total-row subtotal" data-mk-subtotal><span>'
        + (I.cart_subtotal || 'Subtotal') + '</span><span class="cart-total-val"></span></div>';
    cartTotalsSpan.setAttribute('data-mk-totals', '1');
  }

  function renderTotals(cart) {
    const subtotal = cart.total_price / 100;
    // HOTFIX_BUNDLE_SYSTEM_V22 — afficher cart-level discount "You saved" si actif (cart.total_discount, en cents)
    const totalDiscount = (cart.total_discount || 0) / 100;

    if (!cartTotalsSpan.hasAttribute('data-mk-totals')) buildTotalsSkeleton();

    const savingsRow = cartTotalsSpan.querySelector('[data-mk-savings]');
    if (savingsRow) {
      const show = totalDiscount > 0;
      const want = show ? '' : 'none';
      if (savingsRow.style.display !== want) savingsRow.style.display = want;
      if (show) setText(savingsRow.querySelector('.cart-total-val'), '−' + formatMoney(totalDiscount));
    }
    setText(cartTotalsSpan.querySelector('[data-mk-subtotal] .cart-total-val'), formatMoneyWithCode(subtotal));

    setText(checkoutTotalSpan, formatMoneyWithCode(subtotal));
    setText(cartCountSpan, `(${cart.item_count})`);
  }

  // ---------- Skeleton (loader) ----------
  // Affiché pendant le fetch cart.js pour NE JAMAIS montrer l'état « panier vide » périmé juste
  // après un ADD (la vraie cause du flash). L'état vide réel ne s'affiche qu'après confirmation
  // item_count === 0 dans renderCartItems.
  function ensureSkeletonStyles() {
    if (document.getElementById('mk-cart-skel-style')) return;
    var st = document.createElement('style');
    st.id = 'mk-cart-skel-style';
    st.textContent =
      '@keyframes mkCartSkel{0%{background-position:-160px 0}100%{background-position:calc(160px + 100%) 0}}' +
      '.mk-cart-skel-row{display:flex;gap:14px;padding:16px 24px;border-bottom:1px solid rgba(3,2,19,.06)}' +
      '.mk-cart-skel-box{background:#ececed;background-image:linear-gradient(90deg,#ececed 0,#f6f6f7 80px,#ececed 160px);background-size:160px 100%;border-radius:8px;animation:mkCartSkel 1.15s ease-in-out infinite}' +
      '.mk-cart-skel-img{width:80px;height:80px;flex:none}' +
      '.mk-cart-skel-lines{flex:1;display:flex;flex-direction:column;gap:10px;padding-top:4px}' +
      '.mk-cart-skel-line{height:12px}';
    document.head.appendChild(st);
  }
  function skeletonRow() {
    return '<div class="mk-cart-skel-row" aria-hidden="true">'
      + '<div class="mk-cart-skel-box mk-cart-skel-img"></div>'
      + '<div class="mk-cart-skel-lines">'
      + '<div class="mk-cart-skel-box mk-cart-skel-line" style="width:70%"></div>'
      + '<div class="mk-cart-skel-box mk-cart-skel-line" style="width:45%"></div>'
      + '<div class="mk-cart-skel-box mk-cart-skel-line" style="width:30%"></div>'
      + '</div></div>';
  }
  function showSkeleton() {
    ensureSkeletonStyles();
    cartEmptyDiv.classList.remove('visible'); // jamais l'état vide pendant le chargement
    var foot = document.querySelector('.cart-foot');
    if (foot) foot.style.display = ''; // on attend des lignes -> garder le pied (subtotal se remplit)
    cartItemsContainer.innerHTML = skeletonRow() + skeletonRow();
  }

  // ---------- Background scroll lock (mobile / iOS / webview in-app) ----------
  // overflow:hidden sur <body> ne verrouille PAS le scroll sur iOS Safari ni dans le webview
  // in-app Meta : le fond continue de défiler sous le drawer (le footer apparaît). On fige donc
  // le <body> en position:fixed à -scrollY, et on RESTAURE scrollY à la fermeture (sinon la page
  // saute en haut). overscroll-behavior:contain sur .cart-body (CSS) empêche le scroll-chaining.
  let scrollLockY = 0;
  let scrollLocked = false;
  function lockBodyScroll() {
    if (scrollLocked) return; // ne pas re-sauver scrollY si déjà verrouillé (ex. ATC drawer déjà ouvert)
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    const b = document.body.style;
    b.position = 'fixed';
    b.top = '-' + scrollLockY + 'px';
    b.left = '0';
    b.right = '0';
    b.width = '100%';
    b.overflow = 'hidden';
    scrollLocked = true;
  }
  function unlockBodyScroll() {
    if (!scrollLocked) return;
    const b = document.body.style;
    b.position = '';
    b.top = '';
    b.left = '';
    b.right = '';
    b.width = '';
    b.overflow = '';
    scrollLocked = false;
    window.scrollTo(0, scrollLockY); // restaure la position de scroll d'avant l'ouverture
  }

  // ---------- MOBILE : la page panier REMPLACE le tiroir ----------
  // Sur mobile, tout ce qui ouvrait le tiroir mène désormais à la page /cart : icône panier du
  // header, ajout au panier (cart-unified), PDP mkv5, ajout FPT — et n'importe quel bouton
  // ajouté plus tard. Desktop inchangé.
  //
  // La garde est posée sur openDrawer() lui-même, et NULLE PART AILLEURS, parce que c'est le
  // seul endroit du thème qui ouvre le tiroir : les icônes y arrivent par bindCartIcon(), et
  // tous les autres appelants par window.openMatrikarCart — qui EST openDrawer. Un point de
  // contrôle unique = aucun bouton oublié, et aucune règle dupliquée à re-synchroniser un jour.
  //
  // Seuil aligné sur la barre CTA sticky de la page panier (cart-v1-page.css) : sous 820px, la
  // page panier passe en traitement mobile (colonne unique + CTA épinglé), c'est donc bien elle
  // la destination utile. Lu à CHAQUE ouverture, donc une rotation d'écran est prise en compte.
  const MK_MOBILE_CART_MQ = '(max-width: 819px)';

  function isMobileCartMode() {
    return typeof window.matchMedia === 'function' && window.matchMedia(MK_MOBILE_CART_MQ).matches;
  }

  // Marqueur de la page panier. Sert de garde ANTI-BOUCLE : sans lui, un appelant qui ouvre le
  // panier depuis /cart (up-sell) relancerait /cart en boucle et bloquerait la commande.
  function isOnCartPage() {
    return !!document.querySelector('.cart-v1-root');
  }

  // Respecte la locale : '/cart' en EN, '/fr/cart' en FR. Shopify.routes.root vaut '/' ou '/fr/'.
  // Ne jamais coder '/cart' en dur ici : les pages FR ne tombent pas avec les EN.
  function localizedCartUrl() {
    let root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'cart';
  }

  // ---------- Drawer open/close ----------
  function openDrawer() {
    if (isMobileCartMode()) {
      if (isOnCartPage()) {
        // Déjà sur la page panier : on remonte en haut plutôt que de recharger. Évite à la fois
        // le clic mort sur l'icône panier et toute possibilité de boucle de redirection.
        // Scroll instantané volontaire : un scroll 'smooth' est mis en pause par le navigateur
        // quand l'onglet n'est pas au premier plan, et deviendrait donc intestable.
        window.scrollTo(0, 0);
        return;
      }
      window.location.href = localizedCartUrl();
      return;
    }

    syncDrawerViewport();   // P4 : bonne hauteur AVANT la transition d'ouverture (pas de saut visible)
    // Open immediately — don't wait for fetch
    drawer.classList.add('open');
    backdrop.classList.add('open');
    lockBodyScroll();
    document.querySelector('.cart-close')?.focus();
    // Anti-flash « panier vide » : si aucune ligne n'est déjà rendue (ex. 1er ajout depuis un
    // panier vide), on montre un SKELETON jusqu'à l'arrivée du panier frais, au lieu de l'état
    // vide périmé. À la réouverture d'un panier déjà rempli, les .cart-item sont là -> pas de
    // skeleton (contenu correct immédiat), simple refresh en fond.
    // P1-opt (2026-08-05) : lire le panier DÉJÀ en mémoire (window.currentCart — tenu à jour par le
    // bus `mk:cart:changed` après chaque mutation, et par le préload d'init au chargement) plutôt que
    // re-fetch /cart.js à CHAQUE ouverture. Rendu instantané → une requête de moins par ajout.
    if (window.currentCart && window.currentCart.items) {
      renderFromCart(window.currentCart);
    } else {
      // Cas rare : 1er open avant qu'un panier soit connu (préload pas terminé) → skeleton + UN refetch.
      if (!cartItemsContainer.querySelector('.cart-item')) { showSkeleton(); }
      cachedCart = null;
      refreshCartDrawer();
    }
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    unlockBodyScroll();
  }

  // ---------- Cart icon binding ----------
  function bindCartIcon() {
    const selectors = [
      '.site-header__cart',
      '.cart-icon',
      '.header__icon--cart',
      '#cart-icon',
      '[data-cart-toggle]',
      '.js-cart-count',
    ];
    let found = false;
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el) {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          openDrawer();
        });
        found = true;
        break;
      }
    }
    // Bind every cart trigger by its stable hooks (class / aria-controls / href), deduped,
    // skipping the in-drawer "View full cart" link. .mk-cart-link is the reliable header hook
    // across all locales (routes.cart_url shape is not a dependable href$="/cart" match).
    // Null-guard degrades to navigation if the drawer section is ever absent.
    document.querySelectorAll('.mk-cart-link, [aria-controls="cart-drawer"], a[href$="/cart"]').forEach((el) => {
      if (el.closest('.cart-drawer')) return;   // skip #mkViewFullCartLink inside the drawer
      if (el.dataset.mkCartBound) return;        // dedupe (multiple hooks / re-init)
      el.dataset.mkCartBound = '1';
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!drawer || !backdrop) { window.location.href = el.getAttribute('href') || '/cart'; return; }
        openDrawer();
      });
    });
    // Global escape hatch
    window.openMatrikarCart = openDrawer;
  }

  // ---------- Dynamic Express Checkout ----------
  function getCheckoutUrl() {
    // Use Shopify's dynamic checkout token if available
    if (window.Shopify && window.Shopify.checkout && window.Shopify.checkout.token) {
      return '/checkouts/' + window.Shopify.checkout.token;
    }
    return '/checkout';
  }

  function navigateToCheckout(provider) {
    const base = getCheckoutUrl();
    // Each provider uses the same checkout URL; Shopify renders the right button
    // based on shop payment settings. We pass a source hint via query param.
    const url = provider ? base + '?payment=' + encodeURIComponent(provider) : base;
    window.location.href = url;
  }

  // P3 — CHECKOUT : loading + anti-double-clic, SANS toucher à la navigation.
  // On ne met PAS `disabled` sur le bouton et on ne fait aucun preventDefault : la navigation reste
  // exactement `window.location.href` (action critique de conversion, on ne la touche pas). Le
  // double-clic est bloqué par le drapeau `checkoutBusy` ET par `pointer-events:none` d'aria-busy.
  // Filet : si la navigation n'aboutit pas (retour arrière / bfcache / blocage), le bouton redevient
  // cliquable au bout de CHECKOUT_RESET_MS — jamais de checkout mort.
  let checkoutBusy = false;
  const CHECKOUT_RESET_MS = 8000;
  function releaseCheckout() {
    checkoutBusy = false;
    const btn = document.getElementById('mkCheckoutBtn');
    if (btn) btn.removeAttribute('aria-busy');
  }
  function handleCheckoutClick() {
    if (checkoutBusy) return;                       // (6) anti double-submit
    checkoutBusy = true;
    ensureActionStyles();
    const btn = document.getElementById('mkCheckoutBtn');
    if (btn) btn.setAttribute('aria-busy', 'true');
    setTimeout(releaseCheckout, CHECKOUT_RESET_MS);
    navigateToCheckout(null);                       // navigation INCHANGÉE
  }
  // Retour arrière depuis le checkout (bfcache) : le bouton doit être immédiatement réutilisable.
  window.addEventListener('pageshow', releaseCheckout);

  // ---------- P1 (2026-08-05) — BUS PANIER UNIFIÉ (remplace les 3 patchs window.fetch/XHR) ----------
  // Avant : cart-drawer ET mk-gift patchaient window.fetch, chacun refetchant /cart.js sur CHAQUE
  // mutation → cascade de ~8 GET par ajout. Désormais cart-unified.js (le vrai contrôleur d'ajout)
  // émet `mk:cart:changed` avec le panier COMPLET (properties incluses) ; mk-gift le ré-émet après
  // une opération cadeau ; les mutations qty/suppression du drawer aussi. Ici : on RENDRE, zéro GET.
  function renderFromCart(cart) {
    if (!cart || !cart.items) return;
    cachedCart = cart;
    window.currentCart = cart;
    renderCartItems(cart);   // P2 : diff/patch — met à jour en place, n'efface pas la liste
    renderTotals(cart);
  }

  document.addEventListener('mk:cart:changed', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart) { renderFromCart(cart); }
    else { cachedCart = null; refreshCartDrawer(); }   // filet : émetteur sans panier joint → 1 refetch
  });

  // Filet de compat : d'anciens/tiers événements panier. On REND si un panier est joint, sinon
  // on refetch. On n'OUVRE PLUS le drawer ici — l'ouverture à l'ajout est gérée explicitement par
  // cart-unified.js (openCartDrawer). Aucun patch de window.fetch/XHR : ceux-ci sont SUPPRIMÉS.
  ['cart:updated', 'variant:add', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var cart = e && e.detail && e.detail.cart;
      if (cart) renderFromCart(cart);
      else { cachedCart = null; refreshCartDrawer(); }
    });
  });

  // ---------- Init ----------
  // P6 EXTRACT NOTE : script is deferred → DOMContentLoaded may have already fired by the time we run.
  // Handle both cases : if DOM still loading, wait; otherwise run init immediately.
  function init() {
    bindCartIcon();
    bindItemDelegation();   // P2 : délégation posée UNE fois (remplace attachFastEvents par rendu)
    ensureActionStyles();   // P3 : états press/disabled/busy disponibles dès le 1er rendu (le « − » à qty 1 est disabled d'entrée)
    bindViewportSync();     // P4 : hauteur du drawer alignée sur la zone RÉELLEMENT visible
    // Silently preload cart data
    fetchCart()
      .then((cart) => {
        cachedCart = cart;
        window.currentCart = cart;
        renderCartItems(cart);
        renderTotals(cart);
      })
      .catch(console.error);

    // Button events
    document.getElementById('mkCloseCartBtn')?.addEventListener('click', closeDrawer);
    backdrop?.addEventListener('click', closeDrawer);
    document.getElementById('mkCheckoutBtn')?.addEventListener('click', handleCheckoutClick);  // P3 : loading + anti-double-clic
    // HOTFIX_EXPRESS_CHECKOUT_BUTTONS : 4 handlers retirés (mkApplePayBtn, mkGooglePayBtn, mkPayPalBtn, mkShopPayBtn).
    // Les boutons sont désormais rendus par le filtre payment_button natif Shopify qui gère ses propres event handlers + flow natif (Apple Pay sheet, Google Pay popup, Shop Pay accelerated, PayPal redirect).
    document.getElementById('mkShopNowBtn')?.addEventListener('click', () => {
      closeDrawer();
      window.location.href = '/collections/all';
    });
    document.getElementById('mkViewFullCartLink')?.addEventListener('click', (e) => {
      e.stopPropagation();
      closeDrawer();
      window.location.href = '/cart';
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer?.classList.contains('open')) closeDrawer();
    });
  }

  // Image zoom : déplacé dans assets/mk-image-zoom.js (module PARTAGÉ drawer + page cart),
  // chargé globalement via layout/theme.liquid. Les vignettes portent data-zoom-handle ;
  // le module délègue au niveau document → rien à câbler ici.

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
